import { RecordValue, StringValue } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { nonEmptyString, validatePayload } from '../../utils/validate-payload.js';
export const updateIgnoreQueryTrigger = createAction('trigger/query/ignore', (q) => validatePayload(q, new StringValue({ emptyAllowed: true, required: true })));
export const applyQueryTriggerModification = createAction('trigger/query/modification', (payload) => validatePayload(payload, new RecordValue({
    values: { originalQuery: nonEmptyString, modification: nonEmptyString },
})));
